// ClickUp's fixed priority palette — brand colors on a fixed scale, so
// literal hex is intentional here (they don't theme-flip).
export const PRIORITY_OPTIONS = [
  { value: 1, label: 'Urgent', color: '#f50000' },
  { value: 2, label: 'High', color: '#ffcc00' },
  { value: 3, label: 'Normal', color: '#6fddff' },
  { value: 4, label: 'Low', color: '#d8d8d8' },
] as const;

export const UNASSIGNED_CLIENT = 'Unassigned';

export const REVIEW_TABS = ['day-board', 'overdue'] as const;

export const REVIEW_TAB_LABELS: Record<(typeof REVIEW_TABS)[number], string> = {
  'day-board': 'Day board',
  overdue: 'Overdue',
};

export const MEETING_OUTCOME_LABELS = {
  no_tasks: 'No tasks assigned to you',
  no_client: 'Not matched to a client',
} as const;

// One entry per reason the board can be empty of ClickUp data. Collapsing any
// two of these into one screen is what made an empty board undiagnosable.
export const SETUP_COPY = {
  token: {
    title: 'Connect your ClickUp account',
    description: 'Save your personal ClickUp API token in Settings to load your review queue.',
  },
  clients: {
    title: 'No clients assigned to you yet',
    description:
      'Your review queue is drawn from the clients you own. An admin assigns you one in Admin → Clients.',
  },
} as const;

// Radix Select items can't carry an empty-string value — sentinel for
// "create as a new task" (no parent).
export const NO_PARENT_VALUE = '__no_parent__';

export const NO_TASK_TYPE_VALUE = '__no_task_type__';

export const NO_PRIORITY_VALUE = '__no_priority__';
